/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Команда отключения рекуррентного платежа для аккаунта в системе Bank131.
 * Содержит идентификатор аккаунта и имя игровой системы.
 * @export
 * @interface FxIdApplicationStoreBank131DisableRecurrentPaymentRequest
 */
export interface FxIdApplicationStoreBank131DisableRecurrentPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreBank131DisableRecurrentPaymentRequest
     */
    PublicId: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreBank131DisableRecurrentPaymentRequest interface.
 */
export function instanceOfFxIdApplicationStoreBank131DisableRecurrentPaymentRequest(value: object): value is FxIdApplicationStoreBank131DisableRecurrentPaymentRequest {
    if (!('PublicId' in value) || value['PublicId'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestFromJSON(json: any): FxIdApplicationStoreBank131DisableRecurrentPaymentRequest {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentRequestFromJSONTyped(json, false);
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreBank131DisableRecurrentPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'PublicId': json['PublicId'],
    };
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestToJSON(json: any): FxIdApplicationStoreBank131DisableRecurrentPaymentRequest {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentRequestToJSONTyped(json, false);
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestToJSONTyped(value?: FxIdApplicationStoreBank131DisableRecurrentPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PublicId': value['PublicId'],
    };
}

